import dynamic from 'next/dynamic';
import BackgroundTreatment from '@/components/DesignSystem/Base/BackgroundTreatment';
import styles from './DCSPromo.module.css';
import Disclosure from '@/components/Tooltip/Disclosure';
import Avatars from './Avatars';

// Dynamic import to avoid circular dependency
const DynamicFlow = dynamic(
  () => import('@/components/DynamicFlow').then((mod) => mod.DynamicFlow),
  { ssr: true },
);

function DCSPromo() {
  return (
    <section className={'relative w-full max-w-7xl rounded-lg overflow-hidden'}>
      <BackgroundTreatment
        className={
          'relative flex flex-col gap-8 w-full rounded-lg overflow-hidden'
        }
        backgroundColor='bg-secondary-700'
        patternColor='fill-primary-600'
      >
        <div className='relative flex w-full pt-4 pl-4 text-white md:justify-end md:pt-7 md:pl-0 md:pr-8'>
          <Disclosure variant='dcs' position='bottomLeft' />
        </div>
        <div className='flex flex-col gap-10 pt-5 md:pt-[6px] pb-7 px-4 md:px-20'>
          <div
            className={`absolute top-0 left-0 w-full h-full -z-10 ${styles.gradient}`}
          />
          <header className='text-left text-white md:text-center'>
            <span className='font-body-12 font-bold uppercase'>
              Turn your passion into a career
            </span>
            <div>
              <strong className='font-normal text-white not-prose font-heading-h3'>
                Match with a Degree Program in Minutes
              </strong>
            </div>
          </header>

          <Avatars />

          <div>
            <div className='flex flex-col items-start justify-center w-full gap-2 text-white md:items-center'>
              <div className='text-left font-heading-h3 md:text-center'>
                What do you want to study?
              </div>
              <div className='font-body-14 font-light text-left md:text-center'>
                Select your degree and major to see which schools we recommend
                for your area of study.
              </div>
            </div>
            <DynamicFlow needsPlaceholder={false} placement='aboveTheFold' />
          </div>
        </div>
      </BackgroundTreatment>
    </section>
  );
}

export default DCSPromo;
